<template>
  <div slot="pageContent">
    <div>
      <form-accordion :title="$t('common.security.certificat')" :isTitleUpperCase="false">
        <b-row class="d-flex form-group">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="form.name" isMandatory
              :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-button v-if="form.stateCertificat === 1"
           class="back-button btnFilter_2 mr-2 mb-3"
           @click="updateCertificat">
           <i class="fa-light fa-edit"></i>  {{ $t('common.security.update_certificat') }}
         </b-button>
         <b-button v-else
            class="back-button btnFilter_2 mr-2 mb-3"
            @click="cancelCertificat">
            <i class="fa-light fa-times"></i>  {{ $t('common.security.cancel_certificat') }}
          </b-button>
        <b-row
            v-if="certificateText !== '' || form.stateCertificat === 0"
            class="d-flex justify-content-center align-items-center form-group"
        >
          <b-col
              :sm="certificateText === '' ? 6 : 12"
              class="form-group"
          >
            <label
                for="certificate-content"
            >
              {{ $t('common.security.certificat_file_content') }}
              <span class="color-red" aria-hidden="true">*</span>
            </label>

            <b-form-textarea
                id="certificate-content"
                v-model="certificateText"
                required
                style="max-height: none;"
                :placeholder="$t('common.security.enter_something')"
                rows="6"
                @input="processCertificat"
            />
          </b-col>

          <b-col
              v-if="certificateText === '' && form.stateCertificat === 0"
              sm="6"
              class="form-group d-flex flex-column"
          >
            <label
                for="certificate-file"
            >
              {{ $t('common.security.certificat_file') }}
            </label>

            <input
                id="certificate-file"
                type="file"
                accept=".pem, .crt"
                @change="handleFileUploadCertificat"
            >
          </b-col>
        </b-row>
        <b-row class="d-flex align-items-center form-group">
          <b-col sm="6" class="form-group normal-font">
            <form-read-group-label-input :inputValue="getDate(form.startDate)"
              :inputLabel="$t('common.security.startDate')" :placeholderValue="$t('common.security.startDate')">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group normal-font">
            <form-read-group-label-input :inputValue="getDate(form.endDate)"
              :inputLabel="$t('common.security.endDate')" :placeholderValue="$t('common.security.endDate')">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row class="d-flex align-items-center form-group">
          <b-col sm="6" class="form-group normal-font">
            <form-read-group-label-input :inputValue="form.deliveredBy"
              :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group normal-font">
            <form-read-group-label-input :inputValue="form.deliveredTo"
              :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredBy')">
            </form-read-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
      <hr class="mx-auto mb-4" />
      <form-accordion :title="$t('common.security.private_key')" :isTitleUpperCase="false">
        <b-button v-if="form.statePrivateKey === 1"
           class="back-button btnFilter_2 mr-2 mb-3"
           @click="updatePrivateKey">
           <i class="fa-light fa-edit"></i>  {{ $t('common.security.update_privatekey') }}
         </b-button>
         <b-button v-else
            class="back-button btnFilter_2 mr-2 mb-3"
            @click="cancelPrivateKey">
            <i class="fa-light fa-times"></i>  {{ $t('common.security.cancel_privatekey') }}
          </b-button>
        <b-row
            v-if="form.statePrivateKey === 0"
            class="d-flex justify-content-center align-items-center form-group"
        >
          <b-col :sm="privateKeyText === '' ? 6 : 12" class="form-group" >
            <label for="private-key-content">
              {{ $t('common.security.private_key_file_content') }}
              <span class="color-red" aria-hidden="true">*</span>
            </label>

            <b-form-textarea
                id="private-key-content"
                v-model="privateKeyText"
                required
                style="max-height: none;"
                :placeholder="$t('common.security.enter_something')"
                rows="6"
                @input="processPrivateKey"
            />
          </b-col>

          <b-col v-if="privateKeyText === ''" sm="6" class="form-group d-flex flex-column" >
            <label for="private-key-file">
              {{ $t('common.security.private_key_file') }}
            </label>

            <input id="private-key-file" type="file" accept=".pem, .key" @change="handleFileUploadPrivateKey" >
          </b-col>
        </b-row>
        <!-- <b-row class="d-flex justify-content-center align-items-center form-group">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="form.password"
              :inputLabel="$t('common.security.password')" :placeholderValue="$t('common.security.password')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group"></b-col>
        </b-row> -->
        <b-row class="d-flex justify-content-center align-items-center form-group">
          <b-col sm="6" class="form-group">
            <div>
              <label>{{$t('common.security.password')}}</label>
              <div class="d-flex">
                <input v-model="form.password"
                  class="form-control inputAccordionForm inputLogin h-30px"
                  :type="passwordFieldType"
                  autocomplete="off">
                </input>
                <i class="icon icon-password mt-2 pt-1"
                  :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="toggleVisibility">
                </i>
              </div>
            </div>
          </b-col>
          <b-col sm="6" class="form-group"></b-col>
        </b-row>
      </form-accordion>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import forge from 'node-forge'
import CertificatesList from "@/pages/security/CertificatesList.vue"
import _ from "lodash"
import {loadPage} from "@/helpers/routing"

export default {
  name: 'KeystoreFormPEM',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput
  },
  props: {
  store: {
    type: Number,
    default: 1
  },
  keystore: {
    type: Object,
    default: () => ({})
  },
  technicalUser: {
    type: Boolean,
    default: false
  },
  idCertificate: {
    type: String,
    default: ''
  },
  idPrivateKey: {
    type: String,
    default: ''
  },
  idCompany: {
    type: String,
    default: ''
  },
  idUserApi: {
    type: String,
    default: ''
  },
  idRightsProfileApi: {
    type: String,
    default: ''
  }
},
  data () {
    return {
      form: {
        state: 0,
        statePrivateKey: 0,
        stateCertificat: 0,
        privateKey: '',
        certificate: '',
        startDate: '',
        endDate: '',
        deliveredBy: '',
        deliveredTo: '',
        name: '',
        nameDisplay: '',
        pod: '',
        password:'',
        id: '',
        cn: ''
      },
      oldDeliveredBy: '',
      oldDeliveredTo: '',
      oldEndDate: '',
      oldStartDate: '',
      oldCn: '',
      text: '',
      certificateText: '',
      privateKeyText: '',
      name: '',
      caList: [],
      caListPopUp: [],
      podList: [],
      canSaveTrustStore: false,
      certificatList: [],
      passwordFieldType: 'password'
    }
  },
  computed: {
    CertificatesList() {
      return CertificatesList
    },
    isPasswordFieldHidden () {
      return this.passwordFieldType === 'password'
    }
  },
  watch: {
    certificatList: {
      handler() {
        this.checkFormTrustStore()
      },
      deep: true,
    },
    form: {
      handler() {
        this.checkFormTrustStore()
      },
      deep: true,
    },
  },
  created () {
    this.form.id = this.keystore.id
    this.form.name = this.keystore.name
    this.form.endDate = this.keystore.endDate
    this.oldEndDate = this.keystore.endDate
    this.form.startDate = this.keystore.startDate
    this.oldStartDate = this.keystore.startDate
    this.form.deliveredBy = this.keystore.deliveredBy
    this.oldDeliveredBy = this.keystore.deliveredBy
    this.form.deliveredTo = this.keystore.deliveredTo
    this.oldDeliveredTo = this.keystore.deliveredTo
    this.form.cn = this.keystore.cn
    this.oldCn = this.keystore.cn
    //this.form.pod = this.keystore.pod
    this.form.privateKey = this.keystore.privateKey
    this.form.statePrivateKey = 1
    this.form.certificate = this.keystore.certificate
    this.form.password = this.keystore.password
    this.form.stateCertificat = 1
    /*this.$engine.firstOn().routing.pod.fetch()
        .then(resp => {
          if (resp.data.Pods.length != 0){
            this.podList.push({text: this.$i18n.t('common.security.select_an_option'), value: ""})
            resp.data.Pods.forEach(element => {
              this.podList.push({text: element.name, value: element.name})
            })
          }

        })*/
  },
  methods: {
    /*isRightPod(){
      return this.$engine.firstOn().rights.rightIs('pod_consult', true)
    },*/
    isRightKeystore () {
      return this.$engine.firstOn().rights.rightIs('keystore_add', true)
    },
    isRightPrivateKey () {
      return this.$engine.firstOn().rights.rightIs('privatekey_add', true)
    },
    checkFormTrustStore () {
      let flag = true
      this.certificatList.forEach(element =>{
        if (element.startDate == '' || element.endDate == '' || element.certificate == '' || element.nameDisplay == '' || element.name == ''){
          flag = false
        }
      })
      if (flag) {
        this.canSaveTrustStore = true
      } else {
        this.canSaveTrustStore = false
      }
    },
    close () {
      this.showModalElement = false
    },
    updatePrivateKey () {
      this.form.statePrivateKey = 0
      this.form = _.cloneDeep(this.form)
    },
    cancelPrivateKey () {
      this.form.statePrivateKey = 1
      this.privateKeyText = ''
      this.form.startDate = this.oldStartDate
      this.form.endDate = this.oldEndDate
      this.form = _.cloneDeep(this.form)
    },
    updateCertificat () {
      this.form.startDate = ''
      this.form.endDate = ''
      this.form.deliveredBy = ''
      this.form.deliveredTo = ''
      this.form.cn = ''
      this.form.stateCertificat = 0
      this.form = _.cloneDeep(this.form)
    },
    cancelCertificat () {
      this.form.stateCertificat = 1
      this.certificateText = ''
      this.form.startDate = this.oldStartDate
      this.form.endDate = this.oldEndDate
      this.form.deliveredBy = this.oldDeliveredBy
      this.form.deliveredTo = this.oldDeliveredTo
      this.form.cn = this.oldCn
      this.form = _.cloneDeep(this.form)
    },
    processCertificat () {
      try {
        // Traiter le certificat PEM collé dans le textarea
        const certificate = forge.pki.certificateFromPem(this.certificateText)

        // Extraire les informations du certificat
        // const subjectAttributes = certificate.subject.attributes
        // const commonNameAttribute = subjectAttributes.find(attr => attr.name === 'commonName')
        // this.form.name = commonNameAttribute ? commonNameAttribute.value : 'Nom non trouvé'

        this.form.startDate = moment(certificate.validity.notBefore).format('YYYY-MM-DD HH:mm:ss');
        this.form.endDate = moment(certificate.validity.notAfter).format('YYYY-MM-DD HH:mm:ss');


        certificate.issuer.attributes.forEach(element => {
          if (element.name == 'commonName'){
            this.form.deliveredBy = element.value
          }
        })
        certificate.subject.attributes.forEach(element => {
          if (element.name == 'commonName'){
            this.form.deliveredTo = element.value
          }
        })

        // Reconversion du certificat en format PEM (pour l'affichage)
        this.form.certificate = forge.pki.certificateToPem(certificate);

        // Réinitialiser le message d'erreur s'il y en avait
        this.errorMessage = '';

      } catch (err) {
        // En cas d'erreur, afficher un message
        this.errorMessage = this.$i18n.t('common.security.pem_certificate_parsing_error');
        this.form.certificate = '';
        this.form.startDate = '';
        this.form.endDate = '';
        this.form.deliveredBy = '';
        this.form.deliveredTo = '';
      }
    },
    processPrivateKey() {
      try {
        // Traiter le certificat PEM collé dans le textarea
        let privateKey = forge.pki.privateKeyFromPem(this.privateKeyText);

        // Convertir l'objet clé privée en format PEM pour l'afficher
        this.form.privateKey = forge.pki.privateKeyToPem(privateKey);

        // Réinitialiser le message d'erreur s'il y en avait
        this.errorMessage = ''
      } catch (err) {
        // En cas d'erreur, afficher un message
        this.errorMessage = this.$i18n.t('common.security.pem_certificate_parsing_error')
        this.form.certificate = ''
        this.privateKeyText = ''
      }
    },
    handleFileUploadPrivateKey(event) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const keyContent = e.target.result

        try {
          const privateKey = forge.pki.privateKeyFromPem(keyContent)
          this.form.privateKey = forge.pki.privateKeyToPem(privateKey)
          this.privateKeyText = forge.pki.privateKeyToPem(privateKey)

        } catch (err) {
          console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err)
        }
      };

      reader.readAsText(file)
    },
    handleFileUploadCertificat(event, index = null) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const pemContent = e.target.result;

        try {
          const certificate = forge.pki.certificateFromPem(pemContent);
          const pemFormattedCert = forge.pki.certificateToPem(certificate)

          this.certificateText = forge.pki.certificateToPem(certificate)


          const startDate = moment(certificate.validity.notBefore).format('YYYY-MM-DD HH:mm:ss');
          const endDate = moment(certificate.validity.notAfter).format('YYYY-MM-DD HH:mm:ss');

          const subjectAttributes = certificate.subject.attributes;
          const commonNameAttribute = subjectAttributes.find(attr => attr.name === 'commonName');
          const name = commonNameAttribute ? commonNameAttribute.value : 'Nom non trouvé';

          certificate.issuer.attributes.forEach(element => {
            if (element.name == 'commonName'){
              this.form.deliveredBy = element.value
            }
          })
          certificate.subject.attributes.forEach(element => {
            if (element.name == 'commonName'){
              this.form.deliveredTo = element.value
            }
          })

          if (index == null){
            this.form.certificate = pemFormattedCert
            this.form.startDate = startDate
            this.form.endDate = endDate
            this.form.nameDisplay = name
          }else{
            this.certificatList[index].certificate = pemFormattedCert
            this.certificatList[index].startDate = startDate
            this.certificatList[index].endDate = endDate
            this.certificatList[index].nameDisplay = name
          }

        } catch (err) {
          console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err);
        }
      };

      reader.readAsText(file);
    },
    isCertificateAuthority(cert) {
      const basicConstraints = cert.getExtension('basicConstraints');
      return basicConstraints && basicConstraints.cA;
    },
    formatDateTimeFR(iso) {
      return iso.replace(
        /(\d{4})-(\d{2})-(\d{2})T(\d{2}:\d{2}:\d{2})/,
        '$3/$2/$1 $4'
      )
    },
    updateKeystore(){
      let that = this
      if (this.technicalUser) {
        if (this.form.name == '' || this.form.name === undefined) {
          this.$f7.alert(that.$i18n.t('common.security.certif_name_missing'), 'Error')
          return
        } else if (this.form.certificate == '' || this.form.certificate === undefined) {
          this.$f7.alert(that.$i18n.t('common.security.certificate_file_content_missing'), 'Error')
          return
        } else if (this.form.startDate == '' || this.form.startDate === undefined) {
          this.$f7.alert(that.$i18n.t('common.security.start_date_missing'), 'Error')
          return
        } else if (this.form.endDate == '' || this.form.endDate === undefined) {
          this.$f7.alert(that.$i18n.t('common.security.end_date_missing'), 'Error')
          return
        } else if (this.form.privateKey == '' || this.form.privateKey === undefined) {
          this.$f7.alert(that.$i18n.t('common.security.private_key_file_content_missing'), 'Error')
          return
        }
      }
      if (this.technicalUser) {
        if (this.idCertificate && this.idPrivateKey) {
          this.$engine.security.certificates.edit({
            idCertificate: this.idCertificate,
            name: this.form.name,
            certificate: this.form.certificate,
            startDate: this.form.startDate,
            endDate: this.form.endDate,
            deliveredBy: this.form.deliveredBy,
            deliveredTo: this.form.deliveredTo,
            cn: this.form.cn,
            commonName: this.form.cn || this.form.nameDisplay,
            type: 'SSL',
            active: this.getActiveStatus(
              this.form.startDate,
              this.form.endDate
            ),
            technicalUser: this.technicalUser
          })
          .then(() => {
            this.$engine.security.private_keys.edit({
              name: this.form.name,
              idPrivateKey: this.idPrivateKey,
              password: this.form.password,
              passwordVerif: this.form.password,
              privateKey: this.form.privateKey,
              type: "SSL",
              technicalUser: this.technicalUser
            })
            .then(() => {
              that.$f7.modal({
                title: that.$i18n.t("administration.edit_company"),
                buttons: [
                  {
                    text: "OK",
                    onClick() {
                      loadPage(that, { url: "/company/-1" });
                    },
                  },
                ],
              })
            })
            .catch(errPK => {
              errorMessageAlert(errPK, that);
            })
          })
          .catch(errCert => {
            errorMessageAlert(errCert, that);
          })
        } else {
          this.$engine.security.certificates.create({
            idPod: that.form.pod,
            name: that.form.name,
            certificate: that.form.certificate,
            startDate: that.form.startDate,
            endDate: that.form.endDate,
            deliveredBy: that.form.deliveredBy,
            deliveredTo: that.form.deliveredTo,
            commonName: that.form.nameDisplay,
            type: "SSL",
            active: that.getActiveStatus(
              that.form.startDate,
              that.form.endDate
            )
          })
          .then(certificateResponse => {
            let id_certificate = certificateResponse.data.idCertificat
            this.$engine.security.private_keys.create({
              idPod: this.form.pod,
              name: this.form.name,
              privateKey: this.form.privateKey,
              password: this.form.password,
              passwordVerif: this.form.password,
              type: "SSL"
            })
            .then(privateKeyResponse => {
              let id_privatekey = privateKeyResponse.data.idPrivateKey
              this.$engine.company.editCompanyProfileApi({
                idCertificate: id_certificate,
                idPrivateKey: id_privatekey,
                idCompany: this.idCompany,
                technicalUser: this.technicalUser
              })
              .then(() => {
                that.$f7.modal({
                  title: that.$i18n.t("administration.edit_company"),
                  buttons: [
                    {
                      text: "OK",
                      onClick() {
                        loadPage(that, { url: "/company/-1" });
                      },
                    },
                  ],
                })
              })
              .catch(errCompany => {
                errorMessageAlert(errCompany, that);
              })
            })
            .catch(errPK => {
              errorMessageAlert(errPK, that);
            })
          })
          .catch(errCert => {
            errorMessageAlert(errCert, that);
          })
        }
      } else {
        this.$engine.security.certificates.edit({
          idCertificate: this.idCertificate,
          technicalUser: this.technicalUser
        })
        .then(() => {
          this.$engine.security.private_keys.edit({
            idPrivateKey: this.idPrivateKey,
            technicalUser: this.technicalUser
          })
          .then(() => {
            this.$engine.company.editCompanyProfileApi({
              idCompany: this.idCompany,
              technicalUser: this.technicalUser,
              idUserApi: this.idUserApi,
              idRightsProfileApi: this.idRightsProfileApi
            })
            .then(() => {
              that.$f7.modal({
                title: that.$i18n.t("administration.edit_company"),
                buttons: [
                  {
                    text: "OK",
                    onClick() {
                      loadPage(that, { url: "/company/-1" });
                    },
                  },
                ],
              })
            })
            .catch(errCompany => {
              errorMessageAlert(errCompany, that);
            })
          })
          .catch(errPK => {
            errorMessageAlert(errPK, that);
          })
        })
        .catch(errCert => {
          errorMessageAlert(errCert, that);
        })
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    toggleVisibility ($event) {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    getActiveStatus(startDate, endDate) {
      const now = moment()
      const start = moment(startDate, [
        'DD/MM/YYYY HH:mm:ss',
        'YYYY-MM-DD HH:mm:ss',
        moment.ISO_8601
      ])
      const end = moment(endDate, [
        'DD/MM/YYYY HH:mm:ss',
        'YYYY-MM-DD HH:mm:ss',
        moment.ISO_8601
      ])

      if (!start.isValid() || !end.isValid()) {
        return '0'
      }

      // Pas encore commencé
      if (now.isBefore(start)) {
        return '1'
      }

      // Certificat expiré
      if (now.isAfter(end)) {
        return '0'
      }

      // Certificat actuellement actif
      return '2'
    },
    getDate (date) {
      if (!date) return '-';

      const d = new Date(String(date).replace(" ", "T"))
      if (isNaN(d)) return ""
      const pad = n => String(n).padStart(2, "0")
      return (
        `${d.getFullYear()}-` +
        `${pad(d.getMonth() + 1)}-` +
        `${pad(d.getDate())} ` +
        `${pad(d.getHours())}:` +
        `${pad(d.getMinutes())}:` +
        `${pad(d.getSeconds())}`
      )
    },
    convertToDbDateTime(dateTimeStr) {
      if (!dateTimeStr) return ''

      const [date, time] = dateTimeStr.split(' ')
      const [day, month, year] = date.split('/')

      return `${year}-${month}-${day} ${time}`
    }
  }
}
</script>
<style scoped>
.btn.btn-secondary {
  background: var(--actionButtonColorViolet);
  border: 2px solid var(--borderButtonColorBlue);
  color: var(--actionTextColorBlue);
}

.sdd-select {
  display: block;
  width: 90px;
}

.justify-content-around label {
  display: block;
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 2px;
}

.justify-content-around label.sdd-label-main,
.d-flex label.sdd-label-main {
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 1rem !important;
}
.sdd-select-header label {
  display: block;
  text-align: center;
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 2px;
}
.justify-content-around label:not(.sdd-label-main) {
  font-size: 1rem !important;
  color: #212529 !important;
}
.sdd-generation-settings {
  padding: 5px 0 10px 300px;
}
.sct-generation-settings {
  padding: 5px 0 10px 300px;
}
.sct-file-generation-settings {
  padding: 5px 0 10px 300px;
}
.expiring-mandates-settings {
  padding: 5px 0 10px 280px;
}
.generation-row {
  margin-bottom: 2px;
}

.custom-control {
  min-height: 18px;
  padding-left: 25px;
}

.custom-control-label::before,
.custom-control-label::after {
  width: 12px;
  height: 12px;
  top: 3px;
}

.interval-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 25px;
}

.interval-selects {
  display: flex;
  gap: 5px;
  margin-left: 100px;
  margin-top: -2px;
}

.interval-selects select {
  width: 130px;
}
.interval-selects-type {
  display: flex;
  gap: 5px;
  margin-left: 225px;
  margin-top: -2px;
}

.interval-selects-type select {
  width: 160px;
}


.sct-file-row {
  display: flex;
  align-items: flex-start;
}

.sct-file-options {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  margin-top: -4px;
}

.sct-file-options .custom-checkbox {
  margin-bottom: 4px;
}
.space {
  margin-left: 10px;
}
</style>
